<template>
    <div>
        <div
            v-stash:fruit="{ a: 'b' }"
            v-stash:fruit.init="() => console.log('hit')"
            v-stash:fruit.methods="{
                hello(){
                    console.log('hello');
                }
            }"
        >
            <button @click='$s("fruit").call("hello")'>hello</button>
        </div>

        <div
            is="stash"
            id="fruits"
            data="{ apple: 'orange' }"
        >
            {{ $s("fruits").get("apple") }}
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        fName: "applepie",
        items: {
            a: "b",
            c: "d"
        }
    })
};
</script>
